import { colors } from 'nicollet-tokens';

/* eslint-disable unicorn/filename-case */
/**
 * ButtonPrimary
 */

const buttonPrimaryStyles = `
  background-color: ${colors.interactive.primary.default};
  border-color: ${colors.interactive.primary.default};
  color: ${colors.text.onDark.primary};
  font-weight: bold;
`;
const buttonPrimaryHoverStyles = `
  background-color: ${colors.interactive.primary.hover};
  border-color: ${colors.interactive.primary.hover};
  color: ${colors.text.onDark.primary};
`;
const buttonPrimaryActiveStyles = `
  background-color: ${colors.interactive.primary.active};
  border-color: ${colors.interactive.primary.active};
  color: ${colors.text.onDark.primary};
`;
const buttonPrimaryDisabledStyles = `
  color: ${colors.palette.gray.dark};
  background-color: ${colors.palette.gray.light};
  border-color: ${colors.border.container.default};
`;
/**
 * ButtonSecondary
 */

const buttonSecondaryStyles = `
  background-color: ${colors.interactive.secondary.default};
  border-color: ${colors.border.interactive.secondary.default};
  color: ${colors.text.onLight.primary};
`;
const buttonSecondaryHoverStyles = `
  background-color: ${colors.interactive.secondary.hover};
  border-color: ${colors.border.interactive.secondary.hover};
  color: ${colors.text.onLight.primary};
`;
const buttonSecondaryActiveStyles = `
  background-color: ${colors.interactive.secondary.active};
  border-color: ${colors.interactive.secondary.active};
  color: ${colors.text.onDark.primary};
`;
/**
 * ButtonTertiary
 */

const buttonTertiaryStyles = `
  line-height: inherit;
  vertical-align: baseline;
  background-color: transparent;
  border-color: transparent !important;
  color: ${colors.text.onLight.secondary};
  text-decoration: underline;
  padding: 0 !important;
  height: auto !important;
`;
const buttonTertiaryHoverStyles = `
  color: ${colors.text.onLight.primary};
`;
const buttonTertiaryActiveStyles = `
  color: ${colors.text.onLight.primary};
`;
/**
 * ButtonSpecialtyDark
 */

const buttonSpecialtyDarkStyles = `
  background-color: ${colors.background.darkest};
  border-color: ${colors.background.darkest};
  color: ${colors.text.onDark.primary};
`;
const buttonSpecialtyDarkHoverStyles = `
  background-color: ${colors.palette.black};
  border-color: ${colors.palette.gray.darkest};
  color: ${colors.text.onDark.primary};
`;
const buttonSpecialtyDarkActiveStyles = `
  background-color: ${colors.interactive.secondary.active};
  border-color: ${colors.interactive.secondary.active};
  color: ${colors.text.onDark.primary};
`;
/**
 * ButtonSpecialtyRed
 */

const buttonSpecialtyRedStyles = `
  background-color: ${colors.palette.red.red33};
  border-color: ${colors.palette.red.red33};
  color: ${colors.text.onDark.primary};
`;
const buttonSpecialtyRedHoverStyles = `
  background-color: ${colors.palette.red.red24};
  border-color: ${colors.palette.red.red24};
  color: ${colors.text.onDark.primary};
`;
const buttonSpecialtyRedActiveStyles = `
  background-color: ${colors.interactive.secondary.active};
  border-color: ${colors.interactive.secondary.active};
  color: ${colors.text.onDark.primary};
`;

export { buttonPrimaryActiveStyles, buttonPrimaryDisabledStyles, buttonPrimaryHoverStyles, buttonPrimaryStyles, buttonSecondaryActiveStyles, buttonSecondaryHoverStyles, buttonSecondaryStyles, buttonSpecialtyDarkActiveStyles, buttonSpecialtyDarkHoverStyles, buttonSpecialtyDarkStyles, buttonSpecialtyRedActiveStyles, buttonSpecialtyRedHoverStyles, buttonSpecialtyRedStyles, buttonTertiaryActiveStyles, buttonTertiaryHoverStyles, buttonTertiaryStyles };
